import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ScrollToTop from "./scrolltotop";
import Navbar from "./pages/navbar";
import Home from "./pages/home";
import RightSlider from "./pages/slider";
import { SliderProvider } from "./pages/SliderContext";
import Footer from "./pages/footer";
import Abouth from "./pages/abouth-us/abouth";
import Service from "./pages/service/service";
import Contact from "./pages/contact/contact";
import CustomCursor from "./pages/cursor";
import AdminPage from "./components/AdminPage";
import LoginPage from "./components/LoginPage";
import Header from "./components/header";
import Course from "./components/course"; 
import CourseList from "./components/CourseList"; 

const App = () => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => JSON.parse(localStorage.getItem("isAuthenticated")) || false
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const authStatus = JSON.parse(localStorage.getItem("isAuthenticated"));
    setIsAuthenticated(authStatus || false);
    setIsLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // ✅ Show Header on all `/admin/*` pages
  const showHeader = location.pathname.startsWith("/admin") || location.pathname === "/login";
  const hideFooter = ["/login", "/admin", "/admin/course", "/admin/home","/admin/CourseList"].includes(location.pathname);
  const hideHeaderFooter = hideFooter;

  return (
    <>
      <SliderProvider>
        <ScrollToTop />
        {!hideFooter && <CustomCursor />}
        {!hideHeaderFooter && <Navbar />}
        {!hideFooter && <RightSlider />}
 
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Abouth />} />
          <Route path="/our-course" element={<Service />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<LoginPage setIsAuthenticated={handleLogin} />} />

          
          <Route
            path="/admin/"
            element={isAuthenticated ? <AdminPage onLogout={handleLogout} /> : <Navigate to="/login" replace />}
          >
            <Route path="course" element={<Course />} /> 
            <Route path="home" element={<Header />} /> 
            <Route path="CourseList" element={<CourseList />} /> 
          </Route>
        </Routes>
      </SliderProvider>

      {!hideFooter && <Footer />}
    </>
  );
};

export default App;
